import React from "react";
import { CustomerFolder } from "../types";
import { CommandAuthorization, SyncStatus } from "~/gql/types2";
import { OverrideCustomerFolderSync } from "./OverrideCustomerFolderSync";
import { Body1 } from "@material/react-typography";
import { IfAuthorized } from "~/components/IfAuthorized";

type CustomerFolderActionsProps = {
  folder: CustomerFolder;
};

export const CustomerFolderActions: React.FC<CustomerFolderActionsProps> = ({
  folder,
}) => {
  const hasError =
    folder.syncStatus === SyncStatus.Error ||
    folder.syncStatus === SyncStatus.RenameFailed;

  if (
    [SyncStatus.Error, SyncStatus.Unsynced, SyncStatus.RenameFailed].includes(
      folder.syncStatus
    )
  ) {
    return (
      <>
        {hasError && (
          <Body1>
            Sync error: {folder.syncErrorMessage ?? "Unhandled error"}
          </Body1>
        )}
        <IfAuthorized
          command={CommandAuthorization.OverrideCustomerFolderSyncCommand}
        >
          <OverrideCustomerFolderSync folder={folder} />
        </IfAuthorized>
      </>
    );
  }

  return <></>;
};
